let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5ax0n")).then(() => parcelRequire('l7zWx'));